var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"grid-mixed"},[_c('b-row',{staticClass:"grid-mixed-row"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }